import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';
import {parseSaleFilter, saleFilterParams,} from '~/apps/pos/shared/services/qsfilter';
import { setSaleCurrentPage } from '~/apps/pos/shared/actions/sales';

import {createLocationHelper, createStatusHelper} from '~/apps/shared/services/forms';
import { SearchableModelHelper } from '~/lib/forms/select';

import SalesListFilter from '../../components/sales/SalesListFilter';
import { Features } from "~/apps/shared/consts";
import {getSaleStatus, getSaleStatuses} from "~/apps/pos/shared/services/helpers";


class SalesFilter extends React.Component<any, any> {
  locHelper: SearchableModelHelper;
  statusHelper: SearchableModelHelper;

  constructor(props) {
    super(props);

    this.statusHelper = createStatusHelper(this.refresh, getSaleStatus, getSaleStatuses);
    this.locHelper = createLocationHelper(this.refresh, this.getLocById);
  }

  refresh = () => {
    this.forceUpdate();
  };

  getLocById = (locId: string) => {
    return this.props.locations.entities[locId];
  };

  render = () => {
    const { route: { params }, dispatch, auth: { currentUser: {role}}, information, departments } = this.props;
    const filter = parseSaleFilter(params);

    const hasDepartmentFeature = information.entities.features.includes(Features.DEPARTMENTS);
    const departmentsList = departments.ui.currentList.map(id => departments.entities[id]);
    const departmentOptions = departmentsList
      .filter(dep => !filter.locationId || dep.locationId === filter.locationId)
      .map(dep => {
        return {
          label: dep.name,
          value: dep.id,
        }
      })

    return (
      <SalesListFilter
        statusHelper={this.statusHelper}
        filter={filter}
        userRole={role}
        onStatusChange={(statusKey) => {
          filter.status = statusKey;
          navigate('pos.admin.sales', saleFilterParams(filter));
        }}
        onLocationChange={(locationId: string) => {
          filter.locationId = locationId;
          if (filter.departmentId && locationId) {
            const department = departmentsList.find(dep => dep.id === filter.departmentId);
            if (department && department.locationId !== locationId) {
              filter.departmentId = null;
            }
          }
          navigate('pos.admin.sales', saleFilterParams(filter));
        }}
        onFilter={(q: string) => {
          filter.q = q;
          navigate('pos.admin.sales', saleFilterParams(filter));
          dispatch(setSaleCurrentPage(0));
        }}
        locationHelper={this.locHelper}
        hasDepartmentFeature={hasDepartmentFeature}
        departmentOptions={departmentOptions}
        onDepartmentChange={(departmentId: string) => {
          filter.departmentId = departmentId;
          navigate('pos.admin.sales', saleFilterParams(filter));
        }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.admin');

  return {
    locations: state.shared.locations,
    auth: state.shared.auth,
    information: state.shared.information,
    departments: state.shared.departments,
    ...selector(state)
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesFilter);
